import React from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { Grid } from 'react-bootstrap';
import { LoadingTile } from 'components/molecules/ErrorTile';

const SubSiteRedirectContainer = ({ hostEnvName, env }) => {
    const host = env[hostEnvName] || window.location.origin;
    return (
        <Grid fluid={true}>
            <LoadingTile>
                {/*
                 NOTE: Redirect all traffic to subsite that hits this app with a
                 hard redirect to force a reload of the page.
             */}
                {window.location.replace(
                    new URL(window.location.pathname, host)
                )}
            </LoadingTile>
        </Grid>
    );
};

const mapStateToProps = state => ({
    env: get(state, 'config.env', {})
});

export default connect(mapStateToProps, {})(SubSiteRedirectContainer);



// WEBPACK FOOTER //
// ./src/containers/SubSiteRedirectContainer.js